/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RecordDashboardCtaEventRequestBody,
  RecordDashboardCtaEventRequestBody$Outbound,
  RecordDashboardCtaEventRequestBody$outboundSchema,
} from "../components/recorddashboardctaeventrequestbody.js";

export type RecordPlatformMCPDashboardCtaEventSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RecordPlatformMCPDashboardCtaEventRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  recordDashboardCtaEventRequestBody: RecordDashboardCtaEventRequestBody;
};

/** @internal */
export type RecordPlatformMCPDashboardCtaEventSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RecordPlatformMCPDashboardCtaEventSecurity$outboundSchema:
  z.ZodMiniType<
    RecordPlatformMCPDashboardCtaEventSecurity$Outbound,
    RecordPlatformMCPDashboardCtaEventSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function recordPlatformMCPDashboardCtaEventSecurityToJSON(
  recordPlatformMCPDashboardCtaEventSecurity:
    RecordPlatformMCPDashboardCtaEventSecurity,
): string {
  return JSON.stringify(
    RecordPlatformMCPDashboardCtaEventSecurity$outboundSchema.parse(
      recordPlatformMCPDashboardCtaEventSecurity,
    ),
  );
}

/** @internal */
export type RecordPlatformMCPDashboardCtaEventRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RecordDashboardCtaEventRequestBody:
    RecordDashboardCtaEventRequestBody$Outbound;
};

/** @internal */
export const RecordPlatformMCPDashboardCtaEventRequest$outboundSchema:
  z.ZodMiniType<
    RecordPlatformMCPDashboardCtaEventRequest$Outbound,
    RecordPlatformMCPDashboardCtaEventRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      recordDashboardCtaEventRequestBody:
        RecordDashboardCtaEventRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        recordDashboardCtaEventRequestBody:
          "RecordDashboardCtaEventRequestBody",
      });
    }),
  );

export function recordPlatformMCPDashboardCtaEventRequestToJSON(
  recordPlatformMCPDashboardCtaEventRequest:
    RecordPlatformMCPDashboardCtaEventRequest,
): string {
  return JSON.stringify(
    RecordPlatformMCPDashboardCtaEventRequest$outboundSchema.parse(
      recordPlatformMCPDashboardCtaEventRequest,
    ),
  );
}
